<script setup lang="ts">
import type {
  GetPerformanceFinanciereDashboardViewModel,
  performanceFinanciereDashboardSettings,
} from '@/lib/types'
import { generateField } from '@/lib/utils'
import PerformanceFinanciereRepository from '@/repository/PerformanceFinanciereRepository'
import { onMounted, ref } from 'vue'
import CardInfoContent from '@/components/ui/card/CardInfoContent.vue'
import { usePercentageMode } from '@/lib/usePercentageMode'
import Card from '@/components/ui/card/Card.vue'

const settings = ref<performanceFinanciereDashboardSettings | null>(null)
const data = ref<GetPerformanceFinanciereDashboardViewModel | null>()
const fields = ref<{ label: string; value: number; percentage?: number; color?: string }[]>([])
const { isPercentageMode } = usePercentageMode(false)

const updatePerformanceFinanciereCard = () => {
  if (data.value && settings.value) {
    fields.value = [
      generateField(settings.value, data.value, "Chiffre d'affaires", 'chiffre_affaire'),
      generateField(
        settings.value,
        data.value,
        'Frais pédagogique',
        'frais_pedagogique',
        null,
        'Frais pédagogique',
      ),
      generateField(settings.value, data.value, 'Marge brute', 'marge_brute', null, 'Marge brute'),
      generateField(
        settings.value,
        data.value,
        "Chiffre d'affaires par employé",
        'chiffre_affaires_par_employe',
      ),
    ]
  }
}

onMounted(async () => {
  data.value = await PerformanceFinanciereRepository.getInfoCardData()
  settings.value = await PerformanceFinanciereRepository.getSettings()
  updatePerformanceFinanciereCard()
})
</script>

<template>
  <Card
    title="Performance financière (mois)"
    :settings="settings"
    settings-url="/"
    v-model:percentage-mode="isPercentageMode"
    :percent-icon="true"
  >
    <CardInfoContent :fields="fields" :skeletons="4" :percentage-mode="isPercentageMode" />
  </Card>
</template>
